import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { DokaI18NextService } from '@doka/i18next';

export const acceptLanguageInterceptor: HttpInterceptorFn = (req, next) => {
  const lng = inject(DokaI18NextService).selectedLanguage;

  if (!lng || req.headers.has('Accept-Language')) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { 'Accept-Language': lng },
    }),
  );
};
